import { useTranslation } from "react-i18next";
import { useModal } from "context/ModalContext";
import { useToast } from "context/ToastContext";
import { getButtonsNoYesDanger } from "context/helpers/helperModalContext";
import SvgCornerUpLeft from "components/svg/SvgCornerUpLeft";

const useReversalProduct = () => {

    const { t } = useTranslation(['Objects']);
    const { showDlg } = useModal();
    const { showToast } = useToast();

    const paramsDelDlg = {
        buttons : [...getButtonsNoYesDanger(t)], 
        type    : 'confirm',
    } 
 

    const reversalProduct = (cbFunct, showInfo = true) => {
        const p = {
            ...paramsDelDlg,
            text: (<>
                <h4 className="d-flex text-danger">
                <SvgCornerUpLeft className="text-danger"/> 
                <span className="ps-2">{t('confirmReversal')}</span></h4>
                {showInfo && 
                    (<><hr/>
                    <span className="">{t('confirmReversalInfo')}</span></>)}
                </>)
        }
        p.buttons[1].handleClick = () => {  
            showDlg(false);
            cbFunct();
        }
        showDlg(p)
    }
 

    return {
        reversalProduct
    }
}

export default useReversalProduct;